import { gql, useQuery } from '@apollo/client';
import { UserRole } from '@dieterApi/user/useUserQuery';

const COMPANY_USERS = gql`
  query CompanyUsers($page: Int, $pageSize: Int, $search: String, $sortBy: String, $sortOrder: String) {
    companyUsers(page: $page, pageSize: $pageSize, search: $search, sortBy: $sortBy, sortOrder: $sortOrder) {
      users {
        id
        email
        role
        confirmed
        createdAt
        lastLogin
        mfaEnabled
        dpoName
        dpoEmail
        dpoPhone
        dpoAddress
        dpoCompany
        dpoAvatarUrl
        companies {
          id
          name
        }
      }
      total
      page
      pageSize
      totalCompanies
    }
  }
`;

export interface CompanyUser {
  id: string;
  email: string;
  role: UserRole;
  confirmed: boolean;
  createdAt: string;
  lastLogin: string;
  mfaEnabled: boolean;
  dpoName?: string;
  dpoEmail?: string;
  dpoPhone?: string;
  dpoAddress?: string;
  dpoCompany?: string;
  dpoAvatarUrl?: string;
  companies: { id: string; name: string }[];
}

export interface CompanyUsersResult {
  users: CompanyUser[];
  total: number;
  page: number;
  pageSize: number;
  totalCompanies: number;
}

export type CompanyUsersSortField = 'email' | 'role' | 'createdAt' | 'lastLogin' | 'confirmed' | 'mfaEnabled';

export interface CompanyUsersVariables {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: CompanyUsersSortField;
  sortOrder?: 'asc' | 'desc';
}

export interface CompanyUsersData {
  companyUsers: CompanyUsersResult;
}

export function useCompanyUsersQuery(variables?: CompanyUsersVariables) {
  return useQuery<CompanyUsersData, CompanyUsersVariables>(COMPANY_USERS, {
    variables,
    fetchPolicy: 'cache-and-network',
  });
}
